// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5469) return "static/chunks/5469-be9a90644d24ab32.js";
	if (chunkId === 3126) return "static/chunks/3126-e9984171248f4862.js";
	if (chunkId === 6065) return "static/chunks/6065-c5868d17ec5a6a0d.js";
	if (chunkId === 1808) return "static/chunks/1808-2f6d3df1e4a40cd4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"23":"9e17cbbb5b946f29","2215":"182fe94c04afbcf6","5410":"c7903d8773ed8114","8230":"4259cf1aa4480db9"}[chunkId] + ".js";
};